// extracted by mini-css-extract-plugin
module.exports = {"discussionImage":"discussionImage_discussionImage__Nb2QY","attribution":"discussionImage_attribution__7C1wW"};